import React from 'react';
import InviteCard from './InviteCard';

const OnlinePage = () => {
    return (
        <>
            <InviteCard />
        </>
    );
};

export default OnlinePage; 